var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{ref:"table",attrs:{"loading":_vm.loading,"total":_vm.total,"current-page":_vm.page,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"search-config":_vm.searchConfig,"hasAdd":""},on:{"onChangePage":_vm.changeCurrentPage,"onSearch":_vm.onSearch,"onHandle":_vm.tableHandle,"onReset":_vm.onReset,"onAdd":_vm.onAdd}})
}
var staticRenderFns = []

export { render, staticRenderFns }